import { render, staticRenderFns } from "./MyPage.vue?vue&type=template&id=b21bb85e&scoped=true"
import script from "./MyPage.vue?vue&type=script&lang=js"
export * from "./MyPage.vue?vue&type=script&lang=js"
import style0 from "./MyPage.vue?vue&type=style&index=0&id=b21bb85e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21bb85e",
  null
  
)

export default component.exports